import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './Header/Header1.css';
import { useNavigate } from 'react-router-dom';

function Header1() {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleNavClick = (path, state = {}) => {
    navigate(path, { state });
  };

  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);

  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary text-primary" style={{ width: "100%" }}>
      <Container fluid>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto align-items-center" style={{ gap: "20px" }}>
            <Nav.Link onClick={() => handleNavClick('/')} className="Navlinkcolor">HOME</Nav.Link>
            <Nav.Link onClick={() => handleNavClick('/about')} className="Navlinkcolor">ABOUT US</Nav.Link>
            <Nav.Link onClick={() => handleNavClick('/services')} className="Navlinkcolor">OUR SERVICES</Nav.Link>

            <NavDropdown
              title="PRODUCTS"
              id="collapsible-nav-dropdown"
              className="navdropcolor"
              show={showDropdown}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item onClick={() => handleNavClick('/product/solar-plant')}>Solar Power Plant</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick('/product/solar-heater')}>Solar Water Heater</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick('/product/street-light')}>Solar Street Light</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick('/product/ups-battery')}>UPS and Battery</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick('/product/cctv')}>CCTV Camera</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick('/product/ro-softener')}>RO and Softener</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick('/product/lubricants')}>Lubricants</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick('/product/services')}>Services</NavDropdown.Item>
              <NavDropdown.Item onClick={()=> handleNavClick('/products/rental')}>Rental Products</NavDropdown.Item>
              <NavDropdown.Divider />
            </NavDropdown>

            <Nav.Link onClick={() => handleNavClick('/products')} className="Navlinkcolor">SHOPPING</Nav.Link>
            <Nav.Link onClick={() => handleNavClick('/portfolio')} className="Navlinkcolor">PORTFOLIO</Nav.Link>

            <Nav.Link onClick={() => handleNavClick('/', { showCalculator: true })} className="Navlinkcolor" style={{ fontWeight: 'light', color: '#00796b' }}>SOLAR CALCULATOR</Nav.Link>
          </Nav>

          <Nav className="align-items-center" style={{ gap: "15px" }}>
            <Nav.Link onClick={() => handleNavClick('/contact')} className="Navlinkcolor">CONTACT US</Nav.Link>
            <Nav.Link eventKey={2} href="tel:+919994356072" className="mobilenumcolor">
              +91 99943 56072
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header1;